import React from "react";

export default function WalletInterestBanner({ onClick }) {
  return (
    <div className="w-full bg-blue-500/5 border-b border-blue-500/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3">
        <button
          onClick={onClick}
          className="w-full rounded-2xl border border-blue-500/20 bg-blue-500/10 
                     hover:bg-blue-500/15 transition px-4 py-3 text-left"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="text-sm font-semibold text-blue-700 dark:text-blue-300">
              +2 % d’intérêt mensuel sur votre solde wallet
            </div>

            <div className="text-xs font-medium text-blue-800 dark:text-blue-200">
              Recharger →
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}